import { render } from "./LandingPage.vue?vue&type=template&id=51d4f4a4&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=51d4f4a4&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d4f4a4"]])

export default __exports__